module.exports = __webpack_public_path__ + "img/sponsorW24.2a50ffb2.png";